import { render, staticRenderFns } from "./muito-grande.vue?vue&type=template&id=436c2b9a"
import script from "./muito-grande.vue?vue&type=script&lang=js"
export * from "./muito-grande.vue?vue&type=script&lang=js"
import style0 from "./muito-grande.vue?vue&type=style&index=0&id=436c2b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports